import { Form, InputNumber } from "antd";
import { LabeledField } from "../labeledField/labeledField";

export const MaxPayField = ({
  form,
  disabled,
  isFormItem = true,
  extraLabel = null,
  style = {},
}) => {
  const formatter = (value) =>
    `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  const validateEndingFields = (toValue, from) => {
    const fromValue = form.getFieldValue(from);
    if (!toValue && fromValue) {
      return Promise.reject("Enter Max Pay!");
    }
    if (parseInt(fromValue) > parseInt(toValue)) {
      return Promise.reject("Value should be greater than `Min Pay` field");
    }
    return Promise.resolve();
  };

  const renderField = () => (
    <InputNumber
      min={0}
      className="modalInput w-100"
      formatter={formatter}
      disabled={disabled}
      style={style}
    />
  );

  if (isFormItem) {
    return (
      <Form.Item
        label="Max Pay"
        name="maxPay"
        rules={[
          { required: true, message: "Please enter max pay" },
          () => ({
            validator(_, value) {
              return validateEndingFields(value, "minPay");
            },
          }),
        ]}
      >
        {renderField()}
      </Form.Item>
    );
  }

  return (
    <LabeledField label="Max Pay" required extra={extraLabel}>
      {renderField()}
    </LabeledField>
  );
};
